import React, { useState, useEffect } from "react";
import { fetchProcessStatus } from "../Utility/ProcessStatus/processStatusUtils";
import Header from "../components/header";
import ProcessStatusItem from "../components/processStatusItem";
import { retrieveMineData } from '../Utility/ConsumeToken/consumeToken';


function ProcessStatusPage() {
    const [processes, setProcesses] = useState([]);
    const [filterId, setFilterId] = useState("");
    const [filterType, setFilterType] = useState("All");
    const [isLoading, setIsLoading] = useState(true);
    const apitoken = retrieveMineData();

    // Funzione per caricare i processi ogni 2 secondi
    useEffect(() => {
        async function loadProcesses() {
            try {
                const data = await fetchProcessStatus(apitoken._id);
                if (data && data.output) {
                    setProcesses(data.output);
                } else {
                    setProcesses([]);
                }
            } catch (error) {
                console.error("Error loading process statuses:", error);
                setProcesses([]);
            } finally {
                setIsLoading(false);
            }
        }
        loadProcesses();
        const interval = setInterval(loadProcesses, 2000);
        return () => clearInterval(interval);
    });

    // Mappa il valore di "type" in una forma pi� leggibile
    const getDisplayType = (type) => {
        if (type === "/var/www/html/TODO_DEEPSAGE") return "Deepsage";
        if (type === "/var/www/html/TODO") return "ExtractEdge";
        return type; 
    };

    // Filtra i processi in base all'ID e al tipo selezionato
    const filteredProcesses = processes.filter(process => {
        const displayType = getDisplayType(process.type);
        const matchesId = process.id.toLowerCase().includes(filterId.toLowerCase());
        const matchesType = filterType === "All" || displayType === filterType;
        return matchesId && matchesType;
    });

    return (
        <>
            <Header />
            <div className="riga headerStorage">
                <h3 className="titolo titoloManage">Process Status Page</h3>
                <span className="description text">
                    Below is the list of processes currently in queue. You can filter the list by process ID and type.
                </span>
                <div className="space"></div>
                <div className="div50">
                    <label>Search by Process ID:</label>
                    <input
                        className="searchOutput"
                        type="text"
                        placeholder="Enter process ID..."
                        value={filterId}
                        onChange={(e) => setFilterId(e.target.value)}
                    />
                </div>

                <div className="div50">
                    <label>Filter by Type:</label>
                    <select value={filterType} className="selectStatus" onChange={(e) => setFilterType(e.target.value)}>
                        <option value="All">All</option>
                        <option value="Deepsage">Deepsage</option>
                        <option value="ExtractEdge">ExtractEdge</option>
                    </select>
                </div>
                <div className="space"></div>
                <hr />
            </div>
            <div className="riga space-bottom bodyStorage">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    filteredProcesses.length === 0 ? (
                        <p>No processes found.</p>
                    ) : (
                        filteredProcesses.map((process, index) => (
                            <ProcessStatusItem
                                key={index}
                                id={process.id}
                                type={getDisplayType(process.type)}
                                status={process.status}
                                IDD={apitoken._id}
                            />
                        ))
                    )
                )}
            </div>
        </>
    );
}

export default ProcessStatusPage;
